<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-8 col-12">
                <h6 class="mb-0">Município</h6>
                <p>{{documentoPac?.municipioInstalId}} - {{documentoPac?.municipioInstalNome}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8 col-12">
                <h6 class="mb-0">Programa Regional</h6>
                <p>{{documentoPac?.programaNome || '-'}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-8 col-12">
                <h6 class="mb-0">CNAE do Investimento</h6>
                <p>{{documentoPac?.investimentoCnae}} - {{documentoPac?.investimentoCnaeNome}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8 col-12">
                <h6 class="mb-0">CNPJ de Investimento</h6>
                <p>{{documentoPac?.investimentoCnpj || '-'}}</p>
            </div>
        </div>
    </div>
</div>
